// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header-user-info {
  position: absolute;
  top: 0;
  bottom: 0;
  right: 1rem;
  text-align: right;
  z-index: 10;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;
  padding-inline: 20px;
  border-radius: 0;
}
.header-user-info::before {
  content: "";
  position: absolute;
  /* Full-height stripe; extend horizontally so edges aren't clipped */
  inset: 0 -1.25rem;
  pointer-events: none;
  z-index: 0;
  backdrop-filter: blur(6px);
  /* Fade left/right edges so it doesn't end as a hard rectangle */
  -webkit-mask-image: linear-gradient(to right, rgba(0, 0, 0, 0) 0%, rgb(0, 0, 0) 18%, rgb(0, 0, 0) 82%, rgba(0, 0, 0, 0) 100%);
  mask-image: linear-gradient(to right, rgba(0, 0, 0, 0) 0%, rgb(0, 0, 0) 18%, rgb(0, 0, 0) 82%, rgba(0, 0, 0, 0) 100%);
  -webkit-mask-repeat: no-repeat;
  mask-repeat: no-repeat;
  -webkit-mask-size: 100% 100%;
  mask-size: 100% 100%;
  background-image: linear-gradient(to right, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.35) 18%, rgba(0, 0, 0, 0.35) 82%, rgba(0, 0, 0, 0) 100%);
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
.header-user-info > * {
  position: relative;
  z-index: 1;
}
.header-user-info {
  transition: opacity 0.2s ease-in-out;
}
@media (max-width: 576px) {
  .header-user-info {
    display: none !important;
  }
}
@media (min-width: 768px) and (max-width: 992px) {
  .header-user-info {
    right: 0.75rem;
  }
}
@media (min-width: 992px) {
  .header-user-info {
    right: 1.5rem;
  }
}

.user-text-info {
  text-align: right;
  max-width: 280px;
  margin-top: 20px;
  margin-bottom: 0.5rem;
}
.user-text-info .header-username {
  font-weight: 500;
  color: inherit;
  margin-bottom: 0.15rem;
  white-space: nowrap;
  font-size: 0.875rem;
  line-height: 1.2;
}
.user-text-info .header-roles {
  font-size: 0.75rem;
  line-height: 1.2;
  opacity: 0.8;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 280px;
  cursor: default;
}
.user-text-info .header-roles span {
  cursor: default;
}

/* Logout Button Container */
.logout-container {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

/* Logout Button */
.logout-btn {
  color: #dc3545 !important;
  transition: all 0.2s ease-in-out;
  border: 2px solid #dc3545 !important;
  border-radius: 50% !important;
  width: 32px !important;
  height: 32px !important;
  padding: 0 !important;
  line-height: 1 !important;
  flex-shrink: 0;
}
.logout-btn ::ng-deep .mat-icon {
  font-size: 18px !important;
  width: 18px !important;
  height: 18px !important;
  line-height: 18px !important;
}

.logout-btn:hover {
  background-color: rgba(220, 53, 69, 0.1) !important;
  color: #c82333 !important;
  border-color: #c82333 !important;
}`, "",{"version":3,"sources":["webpack://./projects/ai_modernization/src/app/app.component.scss"],"names":[],"mappings":"AAGA;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,WAAA;EACA,iBAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,qBAAA;EACA,oBAAA;EACA,gBAAA;AAFF;AAIE;EACE,WAAA;EACA,kBAAA;EACA,oEAAA;EACA,iBAAA;EACA,oBAAA;EACA,UAAA;EAGA,0BAAA;EAEA,gEAAA;EACA,6HAAA;EAOA,qHAAA;EAOA,8BAAA;EACA,sBAAA;EACA,4BAAA;EACA,oBAAA;EAEA,yIAAA;EAOA,4BAAA;EACA,0BAAA;AAvBJ;AA0BE;EACE,kBAAA;EACA,UAAA;AAxBJ;AAlCA;EA8DE,oCAAA;AAzBF;AA4BE;EAjEF;IAkEI,wBAAA;EAzBF;AACF;AA4BE;EAtEF;IAuEI,cAAA;EAzBF;AACF;AA4BE;EA3EF;IA4EI,aAAA;EAzBF;AACF;;AA6BA;EACE,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,qBAAA;AA1BF;AA6BE;EACE,gBAAA;EACA,cAAA;EACA,sBAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;AA3BJ;AA+BE;EACE,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;AA7BJ;AA+BI;EACE,eAAA;AA7BN;;AAkCA,4BAAA;AACA;EACE,aAAA;EACA,yBAAA;EACA,QAAA;AA/BF;;AAkCA,kBAAA;AACA;EACE,yBAAA;EACA,gCAAA;EACA,oCAAA;EACA,6BAAA;EACA,sBAAA;EACA,uBAAA;EACA,qBAAA;EACA,yBAAA;EACA,cAAA;AA/BF;AAiCE;EACE,0BAAA;EACA,sBAAA;EACA,uBAAA;EACA,4BAAA;AA/BJ;;AAmCA;EACE,mDAAA;EACA,yBAAA;EACA,gCAAA;AAhCF","sourcesContent":["// Header user info positioning\n// Uses position absolute to not interfere with np-header's internal layout\n// This ensures the hallmark/title remains centered\n.header-user-info {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  right: 1rem;\n  text-align: right;\n  z-index: 10;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-end;\n  padding-inline: 20px;\n  border-radius: 0;\n\n  &::before {\n    content: \"\";\n    position: absolute;\n    /* Full-height stripe; extend horizontally so edges aren't clipped */\n    inset: 0 -1.25rem;\n    pointer-events: none;\n    z-index: 0;\n\n    -webkit-backdrop-filter: blur(6px);\n    backdrop-filter: blur(6px);\n\n    /* Fade left/right edges so it doesn't end as a hard rectangle */\n    -webkit-mask-image: linear-gradient(\n      to right,\n      rgba(0, 0, 0, 0) 0%,\n      rgba(0, 0, 0, 1) 18%,\n      rgba(0, 0, 0, 1) 82%,\n      rgba(0, 0, 0, 0) 100%\n    );\n    mask-image: linear-gradient(\n      to right,\n      rgba(0, 0, 0, 0) 0%,\n      rgba(0, 0, 0, 1) 18%,\n      rgba(0, 0, 0, 1) 82%,\n      rgba(0, 0, 0, 0) 100%\n    );\n    -webkit-mask-repeat: no-repeat;\n    mask-repeat: no-repeat;\n    -webkit-mask-size: 100% 100%;\n    mask-size: 100% 100%;\n\n    background-image: linear-gradient(\n      to right,\n      rgba(0, 0, 0, 0) 0%,\n      rgba(0, 0, 0, 0.35) 18%,\n      rgba(0, 0, 0, 0.35) 82%,\n      rgba(0, 0, 0, 0) 100%\n    );\n    background-repeat: no-repeat;\n    background-size: 100% 100%;\n  }\n\n  > * {\n    position: relative;\n    z-index: 1;\n  }\n  \n  // Smooth transitions for better UX\n  transition: opacity 0.2s ease-in-out;\n  \n  // Responsive: hide on small screens\n  @media (max-width: 576px) {\n    display: none !important;\n  }\n  \n  // Adjust positioning on medium screens\n  @media (min-width: 768px) and (max-width: 992px) {\n    right: 0.75rem;\n  }\n  \n  // Optimal positioning on large screens\n  @media (min-width: 992px) {\n    right: 1.5rem;\n  }\n}\n\n// User text info container\n.user-text-info {\n  text-align: right;\n  max-width: 280px;\n  margin-top: 20px;\n  margin-bottom: 0.5rem;\n  \n  // Username styling\n  .header-username {\n    font-weight: 500;\n    color: inherit;\n    margin-bottom: 0.15rem;\n    white-space: nowrap;\n    font-size: 0.875rem;\n    line-height: 1.2;\n  }\n  \n  // Roles styling\n  .header-roles {\n    font-size: 0.75rem;\n    line-height: 1.2;\n    opacity: 0.8;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    max-width: 280px;\n    cursor: default;\n    \n    span {\n      cursor: default;\n    }\n  }\n}\n\n/* Logout Button Container */\n.logout-container {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n}\n\n/* Logout Button */\n.logout-btn {\n  color: #dc3545 !important;\n  transition: all 0.2s ease-in-out;\n  border: 2px solid #dc3545 !important;\n  border-radius: 50% !important;\n  width: 32px !important;\n  height: 32px !important;\n  padding: 0 !important;\n  line-height: 1 !important;\n  flex-shrink: 0;\n  \n  ::ng-deep .mat-icon {\n    font-size: 18px !important;\n    width: 18px !important;\n    height: 18px !important;\n    line-height: 18px !important;\n  }\n}\n\n.logout-btn:hover {\n  background-color: rgba(220, 53, 69, 0.1) !important;\n  color: #c82333 !important;\n  border-color: #c82333 !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
